<template>
  <div v-if="learnerData">
    <ProfileHero :has-asurite="hasAsurite" @editProfile="editProfile" />
    <v-container v-if="!hasAsurite" class="container pt-4">
      <div class="pa-4" style="border-left: 4px solid #8c1d40; background: #f8f4f5; border-radius: 4px">
        <div class="text-body-1 font-weight-bold mb-1">Profile editing isn't available yet</div>
        <div class="text-body-2">You'll be able to update your profile once your ASURITE ID has been issued.</div>
      </div>
    </v-container>
    <ProfileDetails
      :shouldRefreshData="shouldRefreshData"
      :learnerData="learnerData"
      :collectDemographicInfo="collectDemographicInfo"
    />
    <EditProfileModal
      v-model="openEditProfile"
      :learnerData="learnerData"
      :collectDemographicInfo="collectDemographicInfo"
      @editProfile="editProfile"
      @closeModal="editProfile"
    />
  </div>
  <div v-show="false">{{ detectChange }}</div>
</template>

<script>
import { defineComponent } from 'vue';

import { useUserStore } from '@/stores/user';
import { SessionInitializer } from '../mixins/sessionInitializer';
import ProfileHero from '../components/ProfileHero.vue';
import ProfileDetails from '../components/ProfileDetails.vue';
import EditProfileModal from '../components/EditProfileModal.vue';
import { AjaxLoader } from '../mixins/ajaxLoader';
import { DataLayerMixin } from '../mixins/dataLayerMixin.js';

export default defineComponent({
  name: 'ProfileView',

  components: {
    ProfileHero,
    ProfileDetails,
    EditProfileModal
  },

  data() {
    return {
      openEditProfile: false,
      learnerData: null,
      collectDemographicInfo: null,
      demographicInfo: {},
      educationalInfo: {},
      shouldRefreshData: false
    };
  },

  mixins: [SessionInitializer, AjaxLoader, DataLayerMixin],

  methods: {
    editProfile() {
      if (!this.openEditProfile) {
        this.asuoDataLayerClick('editProfileModal', '2');
      }
      this.openEditProfile = !this.openEditProfile;
    },
    assignLearnerInfo() {
      this.learnerData = this.$conn.learnerData.basicLearnerInformation;
      this.learnerData = {
        ...this.learnerData,
        currentHighSchool: this.educationalInfo.currentHighSchool,
        highSchoolExpectedGraduationDate: this.educationalInfo.highSchoolExpectedGraduationDate
      };

      this.collectDemographicInfo = this.$conn.learnerData._collectDemographicInfo;
    }
  },

  created() {
    this.init('profile', () => {
      this.educationalInfo = this.$conn.getEducationalInformation(); // Calling Educational Info
      this.assignLearnerInfo();
      this.demographicInfo = this.$conn.getDemographicInformation();
    });
  },

  props: {
    refreshDashboardPage: {
      type: Object
    }
  },

  computed: {
    // Read the store LearnerModel — the learnerData prop carries no ASURITE.
    hasAsurite() {
      const userStore = useUserStore();
      return !!userStore.apis?.learnerData?._asuRite;
    },
    detectChange() {
      if (this.shouldRefreshData || this.refreshDashboardPage.dashboard) {
        this.getLearnersData();

        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.shouldRefreshData = true;
      }

      return this.refreshDashboardPage.dashboard;
    }
  },

  watch: {
    'refreshDashboardPage.dashboard'() {
      // Force refresh when dashboard prop changes
      this.getLearnersData();
      // Also update collectDemographicInfo since mixin no longer does this
      this.collectDemographicInfo = this.$conn.learnerData._collectDemographicInfo;
    }
  }
});
</script>

<style lang="stylus"></style>
